export default __webpack_public_path__ + "static/media/Chest.2bfa533c.svg";